import React, { useState, useCallback } from "react";
import useLayoutEffect from "hooks/useIsomorphicLayoutEffect";

function getDimensionObject(node) {
  const rect = node.getBoundingClientRect();

  return {
    width: rect.width,
    height: rect.height,
    top: "x" in rect ? rect.x : rect.top,
    left: "y" in rect ? rect.y : rect.left,
    x: "x" in rect ? rect.x : rect.left,
    y: "y" in rect ? rect.y : rect.top,
    right: rect.right,
    bottom: rect.bottom,
  };
}

const useClientRect = () => {
  const [rect, setRect] = useState({});
  const [node, setNode] = useState(null);

  const ref = useCallback(node => {
    setNode(node);
  }, []);

  useLayoutEffect(() => {
    if (node) {
      const measure = () => window.requestAnimationFrame(() => setRect(getDimensionObject(node)));
      measure();

      window.addEventListener("resize", measure);

      // remember: clean-up in hooks = a return function!
      return () => {
        window.removeEventListener("resize", measure);
      };
    }
  }, [node]);

  return [ref, rect, node];
};

export default useClientRect;
